import { Component, OnInit, Input } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { AppSettingService, EUILanguage } from '../app.service';
import { UserInfoService } from '../user/user-info.service';
import { VisitHistoryAPIService } from '../user/account-api.service';
import { NavigationBackService, NavigationHistoryService } from './navigation-history.service';

@Component({
	selector: 'app-navigation-history',
	templateUrl: './navigation-history.component.html',
	styleUrls: ['./navigation-history.scss'],
	standalone: false
})
export class NavigationHistoryComponent implements OnInit {
	uiLang: EUILanguage = EUILanguage.English;
	@Input() set lang(v: EUILanguage) { this.uiLang = v; }
	@Input() noBack: boolean = false;
	@Input() forMap: boolean = false;

	ellipsisEntries: any;

	constructor(
		public userInfo: UserInfoService,
		private backStack: NavigationBackService,
		private router: Router,
		private historyReception: NavigationHistoryService,
		private location: Location,
		private dialog: MatDialog
	) { }

	dropdownWidth: string = '350px'; //used by template: can be made responsive here if needed.

	backButtonClick() : void {
		this.backStack.backButtonClick();
	}

	goViewAll(e: any) : void {
		let modalInstance = this.dialog.open(
			NavigationHistoryAllDialog,
			{
				height: '95vh',
				minWidth: '400px',
				panelClass: 'jmDialog',
				disableClose: false,
				autoFocus: true
			}
		);

		modalInstance.afterClosed().subscribe(
			result => {
				if (result != undefined) {
					//result from modal was clear history
					if (result === "clearHistory") {
						this.historyReception.clearEllipsisEntries();
					}
					//result from modal was search term
					if (result.term !== undefined) {
						this.backStack.ellipsisSearchTerm = result.term;
						this.backStack.mapEllipsisSearchTerm = result.term;
					}
				}
			}
		);
	}

	ellipsisClick(ellipsisEntry: any, link: string) : void {
		//every time user clicks on ellipsis, latest info populated for ng-repeat
		this.ellipsisEntries = this.historyReception.ellipsisEntries;
		if (ellipsisEntry.headerName.toLowerCase() === "search") {
			this.backStack.ellipsisSearchTerm = ellipsisEntry.links[0].linkName;
			if (this.location.path() === '/Map') {
				this.backStack.mapEllipsisSearchTerm = ellipsisEntry.links[0].linkName;
			}
			else {				
				this.router.navigateByUrl("/Map?search=" + ellipsisEntry.links[0].linkName);
			}
		}
		else {
			//$location.url(e.target.attributes.data.nodeValue);
			if (ellipsisEntry.NewUI) {
				this.router.navigateByUrl(link);
			}
			else {
				window.location.href = AppSettingService.journeyUI + link;
			}
		}
	}

	ngOnInit(): void {
		this.backStack.ellipsisSearchTerm = null;
		this.ellipsisEntries = this.historyReception.ellipsisEntries;
	}
}

@Component({
	selector: 'app-navigation-history-all',
	templateUrl: './navigation-history.dialog.html',
	styleUrls: ['./navigation-history.scss'],
	standalone: false
})
export class NavigationHistoryAllDialog implements OnInit {
	@Input() noBack: boolean = false;
	@Input() searchTermCallback: (args: any) => void;

	constructor(
		private visitAPI: VisitHistoryAPIService,
		private location: Location,
		private dialogRef: MatDialogRef<NavigationHistoryAllDialog>,
		private router: Router
	)
	{ }

	curPage: number = 0;
	itemsPerPage: number = 10;
	totalItems: number = 0;
	endReached: boolean = false;
	dateItems: {
		date: any,
		historyEntries: any[]
	}[] =[];

	ngOnInit(): void {
		this.curPage = 0;
		this.getItems();
	}

	closeModal() {
		this.dialogRef.close("Dismiss");
	}

	clearHistory() {
		this.visitAPI.clearHistory().subscribe(
			response => {
				this.dialogRef.close("clearHistory");
			},
			error => {
				console.log(error)
			}
		);
	}

	private getItems() : void {
		if (this.endReached !== true) {
			this.visitAPI.getRecent(this.curPage * this.itemsPerPage, this.itemsPerPage + 1).subscribe(
				results => {
					this.totalItems = results.length;
					if (results.length < this.itemsPerPage + 1) {
						this.endReached = true;
					}

					if (results.length > 0) {
						this.dateItems = this.formatItems(results);
						if (results.length < this.itemsPerPage) {
							this.endReached = true;
						}
					}
				},
				error => {
					console.log(error)
				}
			);
		}
	}

	private formatItems(items: any): any {
		var dateItems = [
			{
				date: items[0].TimeStamp,
				historyEntries: [] as any[]
			}
		];

		//first build array of unique date day objects where each object includes array of ellipsis entries
		for (var i = 1; i < items.length; i++) {
			if (new Date(items[i].TimeStamp).getDay() !== new Date(items[i - 1].TimeStamp).getDay()) {
				//new date found so push it
				dateItems.push({ date: items[i].TimeStamp, historyEntries: [] });
			}
		}

		//then for each of those date objects, cycle through the entries and add the dates that match
		for (var i = 0; i < dateItems.length; i++) {
			for (var j = 0; j < items.length; j++) {
				if (new Date(items[j].TimeStamp).getDay() === new Date(dateItems[i].date).getDay()) {
					dateItems[i].historyEntries.push({ date: items[j].TimeStamp, ellipsisEntry: JSON.parse(items[j].EllipsisEntryJson)})
				}
			}
		}
		return dateItems;
	}

	goTo(href: any) {
		var absUrl = this.location.path().split('?')[0];
		var path = absUrl.substring(0, absUrl.lastIndexOf("/") + 1);
		window.open(path + href, '_blank');
	}

	decPage() {
		if (this.endReached === true) {
			this.endReached = false;
		}
		if (this.curPage > 0) {
			this.curPage--;
			this.getItems();

		}
	}

	incPage() {
		if (this.endReached !== true) {
			this.curPage++;
			this.getItems();
		}
	}

	getDate(date: any) {
		var d = new Date(date);
		return (d.getMonth() + 1) + '/' + d.getDate() + '/' + d.getFullYear();
	}

	ellipsisClick(ellipsisEntry: any, link: string) {
		if (ellipsisEntry.headerName.toLowerCase() === "search") {
			this.dialogRef.close({ term: ellipsisEntry.links[0].linkName });
		}
		else {
			this.closeModal();
			if (ellipsisEntry.NewUI) {
				this.router.navigateByUrl(link);
			}
			else {
				window.location.href = AppSettingService.journeyUI + link;
			}
		}
	}
}

